<template>
  <div class="multi-banner-container" v-if="cellList.length > 0" id="text-banner-swiper" ref="textBannerContainer">
    <swiper :options="swiperOption" ref="textBanner" @click.native="goDetail()">
      <swiper-slide v-for="(cell, index) in cellList" :key="genTime + index">
        <BannerTextItem :bannerInfo="cell" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" />
    </swiper>
  </div>
</template>
<script>
import { get } from 'lodash'
import EventModelClass from '@/common/model/EventModelClass'
import { AnalizeService, EventService } from '@/common/api/api.service'
import BannerTextItem from './banner/BannerTextItem'
import { getEventListByType } from '@/common/util/event.util'
import { bannerLink } from '@/common/util/common'
export default {
  name: 'BannerText',
  props: ['sectionInfo'],
  components: {
    BannerTextItem
  },
  data () {
    return {
      cellList: [],
      genTime: '',
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 8,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        loop: true,
        centeredSlides: true,
        autoplay: {
          running: true,
          timeout: 3500,
          disableOnInteraction: false
        },
        speed: 700,
      }
    }
  },
  methods: {
    goDetail () {
      const bannerIndex = this.$refs.textBanner.swiper.clickedSlide.dataset.swiperSlideIndex
      const { onNavigationEvent, onClickEvent } = getEventListByType(this.cellList[bannerIndex].event_list)
      if (onClickEvent) {
        AnalizeService.sendLogList([onClickEvent]).then(() => {
          bannerLink(onNavigationEvent.url)
        })
      } else {
        bannerLink(onNavigationEvent.url)
      }
    }
  },
  mounted () {
    window.addEventListener('resize', this.resize)
  },
  created () {
    EventService.requestEventData(new EventModelClass(this.sectionInfo.contentEvent)).then(({ data }) => {
      this.genTime = get(data, 'gen_time', '')
      this.cellList = get(data, ['band', 'celllist'], [])
    })
  }
}
</script>
